/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserEmail } from '../models/UserEmail';
import type { UserEmailPatch } from '../models/UserEmailPatch';
import type { UserEmailPost } from '../models/UserEmailPost';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminEmailService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List all e-mails belonging to this user.
     * @param id The user id.
     * @returns UserEmail Default Response
     * @throws ApiError
     */
    public getUserEmails(
        id: number,
    ): CancelablePromise<Array<UserEmail>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/users/{id}/emails',
            path: {
                'id': id,
            },
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * Create an e-mail address and assign it to this user.
     * @param id The user id.
     * @param requestBody
     * @returns UserEmail Default Response
     * @throws ApiError
     */
    public postUserEmail(
        id: number,
        requestBody: UserEmailPost,
    ): CancelablePromise<UserEmail> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/admin/users/{id}/emails',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * Fetch email details.
     * @param id The email id.
     * @returns UserEmail Default Response
     * @throws ApiError
     */
    public getUserEmail(
        id: number,
    ): CancelablePromise<UserEmail> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/email/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Default Response`,
            },
        });
    }
    /**
     * Update an email.
     * @param id The email id.
     * @param requestBody
     * @returns UserEmail Default Response
     * @throws ApiError
     */
    public patchUserEmail(
        id: number,
        requestBody: UserEmailPatch,
    ): CancelablePromise<UserEmail> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/admin/email/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * Update an email.
     * @param id The email id.
     * @param requestBody
     * @returns UserEmail Default Response
     * @throws ApiError
     */
    public putUserEmail(
        id: number,
        requestBody: UserEmailPost,
    ): CancelablePromise<UserEmail> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/admin/email/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * Delete an email.
     * @param id The email id.
     * @returns any Default Response
     * @throws ApiError
     */
    public deleteUserEmail(
        id: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/admin/email/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Default Response`,
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
}
